export const OptimalBlueLaunchButtonText = {
  BUTTON: 'Price in Optimal Blue',
  DIALOG_HEADER: 'Optimal Blue Pricing',
  NOT_ENABLED: 'Optimal Blue pricing is not enabled for this company.',
};

export const LaunchUiDialogSize = {
  HEIGHT: '700px',
  WIDTH: '100%',
};
